import watchListUpdateLogs from './watchlistUpdateLogsReducer';

import singleClientReportEntries from './single-client/singleClientReportEntriesReducer';
import singleClientReportDetails from './single-client/singleClientReportDetailsReducer';
import exportSingleClientReportPdf from './single-client/exportSingleClientReportPdfReducer';

import exportMultipleClientReportPdf from './exportMultipleClientReportPdfReducer';
import multipleClientsReport from './multipleClientsReportReducer';
import exportMultipleClientReportHtml from './exportMultipleClientReportHtmlReducer';

import exportScoringResultsReportCsv from './scoring-results/exportScoringResultsReportCsvReducer'
import scoringResultsReportEntries from './scoring-results/scoringResultsReportEntriesReducer'

export { 
    watchListUpdateLogs, 
    multipleClientsReport,
    singleClientReportEntries,
    singleClientReportDetails,
    exportSingleClientReportPdf,
    exportMultipleClientReportPdf,
    exportMultipleClientReportHtml,
    exportScoringResultsReportCsv,
    scoringResultsReportEntries,
};


// WEBPACK FOOTER //
// ./src/features/reports/reducers/index.js